import React from 'react';
import classes from './section.module.scss';

const Section = ({ count, title, maxLimit, click, children }: any) => {
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>
        {title}{' '}
        <a onClick={click}>
          Усі ({maxLimit ? `${count} з ${maxLimit}` : count})
        </a>
      </h2>
      {children}
    </div>
  );
};

export default Section;
